export const SURVEY_ID = {
  SLOW_NO_GROWTH: '6496270775009124',
  GROWING_RURAL:  '8612039853451392',
  URBAN:          '0961254345091306',
}